"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
require("./contactInfo.scss");
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const staticDataSlice_1 = require("../../../../redux/slices/staticDataSlice");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const common_1 = require("../../../../utils/common");
const svgIcons_1 = require("../../../../svgIcons");
const StateFieldComponent = (params, error, placeholder) => {
    return (react_1.default.createElement(core_1.TextField, Object.assign({ "data-qa": 'state' }, params, { error: !!error, placeholder: placeholder })));
};
const PhoneNumberMask = (props) => {
    const other = __rest(props, []);
    return (react_1.default.createElement(react_input_mask_1.default, Object.assign({}, other, { mask: "(999) 999-9999", maskChar: " " })));
};
const PostalCodeMask = (props) => {
    const other = __rest(props, []);
    return (react_1.default.createElement(react_input_mask_1.default, Object.assign({}, other, { mask: "99999", maskChar: "" })));
};
const ContactInfo = (props) => {
    react_1.useEffect(() => {
        props.getStates();
    }, []);
    const { states } = props.staticData;
    const { full_address } = props.formData;
    const mappedStates = states.map(val => {
        return {
            "state_id": val.id,
            "state_name": val.name,
            "state_abbrev": val.abbreviation
        };
    });
    const userState = mappedStates.filter(el => el.state_id === props.formData.full_address.state_id)[0] || null;
    const user = props.user;
    // handle state input change
    const stateSelectChange = (e, value) => {
        props.formChange(null, 'full_address[state_id]', value === null || value === void 0 ? void 0 : value.state_id);
        props.formChange(null, 'full_address[state_abbrev]', value === null || value === void 0 ? void 0 : value.state_abbrev);
    };
    return (react_1.default.createElement(core_1.Box, { id: 'contact-info-block' }, !props.edit ? react_1.default.createElement("div", { className: `info-wrapper ${user.full_address.stringified ? 'full-address' : ''}` },
        react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement("p", { className: "title" }, "Main:"),
            react_1.default.createElement("a", { href: `tel:${user.contact_person}`, className: 'text' }, user.contact_person)),
        user.additional_phone && react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement("p", { className: "title" }, "Extra:"),
            react_1.default.createElement("a", { href: `tel:${user.additional_phone}`, className: 'text' }, user.additional_phone)),
        user.email && react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement("p", { className: "title" }, "Email:"),
            react_1.default.createElement("a", { href: `mailto:${user.email}`, className: 'text' }, user.email)),
        user.website && react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement("p", { className: "title" }, "Website:"),
            react_1.default.createElement("a", { onClick: (e) => common_1.goExternalUrl(`//${user.website}`, '_blank', e), className: 'text' }, user.website)),
        user.full_address.stringified &&
            react_1.default.createElement("div", { className: "wrapper" },
                react_1.default.createElement("p", { className: "title" }, "Address:"),
                react_1.default.createElement("a", { onClick: (e) => common_1.openMapAddress(user.full_address.stringified, e), className: 'text' }, user.full_address.stringified))) :
        react_1.default.createElement("div", { className: "inputs-wrapper" },
            react_1.default.createElement("div", { className: "inputs-group" },
                react_1.default.createElement(core_1.TextField, { placeholder: 'Phone Number', "data-qa": 'main-phone-num', error: props.validationFields.contactPersonValid === false, value: props.formData.contact_person, onChange: (e) => props.formChange(e, 'contact_person'), onBlur: (e) => props.validateInput(e, 'contact_person'), InputProps: {
                        inputComponent: PhoneNumberMask,
                    } }),
                react_1.default.createElement(core_1.TextField, { value: props.formData.additional_phone || '', error: props.validationFields.additionalPhoneValid === false, placeholder: 'Extra Phone Number (optional)', "data-qa": 'additional-phone-num', onChange: (e) => props.formChange(e, 'additional_phone'), onBlur: (e) => props.validateInput(e, 'additional_phone'), InputProps: {
                        inputComponent: PhoneNumberMask
                    } }),
                react_1.default.createElement(core_1.TextField, { placeholder: 'Email (optional)', "data-qa": 'email', error: props.validationFields.emailValid === false, onChange: (e) => {
                        props.formChange(e, 'email');
                    }, onBlur: (e) => props.validateInput(e, 'email'), value: props.formData.email }),
                react_1.default.createElement(core_1.TextField, { placeholder: 'Website (optional)', "data-qa": 'website', error: props.validationFields.websiteValid === false, onChange: (e) => props.formChange(e, 'website'), onBlur: (e) => props.validateInput(e, 'website'), value: props.formData.website || '' }),
                react_1.default.createElement(Autocomplete_1.default, { id: "select-state", popupIcon: react_1.default.createElement(svgIcons_1.DropdownIcon, { fill: "#2EA0DC" }), value: userState, options: mappedStates, onChange: stateSelectChange, getOptionLabel: (option) => option.state_name || '', renderInput: params => StateFieldComponent(params, false, 'State') }),
                react_1.default.createElement(core_1.TextField, { placeholder: 'City', "data-qa": 'city', error: !props.addressValid && !full_address.city, value: full_address.city || '', onChange: (e) => props.formChange(e, 'full_address[city]'), onBlur: () => props.validateAddress() }),
                react_1.default.createElement(core_1.TextField, { placeholder: 'Address', "data-qa": 'address', error: !props.addressValid && !full_address.street, value: full_address.street || '', onChange: (e) => props.formChange(e, 'full_address[street]'), onBlur: () => props.validateAddress() }),
                react_1.default.createElement(core_1.TextField, { placeholder: 'Zip', "data-qa": 'zip-code', error: props.validationFields.zipCodeValid === false || !props.addressValid && !full_address.zip_code, value: full_address.zip_code || '', onChange: (e) => props.formChange(e, 'full_address[zip_code]'), onBlur: (e) => {
                        props.validateInput(e, 'zip_code');
                        props.validateAddress();
                    }, InputProps: {
                        inputComponent: PostalCodeMask,
                    } })))));
};
const mapStateToProps = (state) => {
    const { staticData } = state;
    return {
        staticData
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getStates: () => dispatch(staticDataSlice_1.getStates())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
